import React from "react";
import DesktopBehavioralChart from "@/components/charts/DesktopBehavioralChart";
import { useIsMobile } from "@/hooks/use-mobile";
import { BehavioralFactor } from "@/types/resultsTypes";
import { factorsToChartData } from "@/utils/normalizeBehavioralChartData";
import EmptyState from "../states/EmptyState";

interface BehavioralSectionProps {
  factors: BehavioralFactor[];
  title: string;
  icon: React.ReactNode;
  wordsCount: number;
  isVisible: boolean;
  showChart?: boolean;
  showKeyInsights?: boolean;
}


const BehavioralSection: React.FC<BehavioralSectionProps> = ({
  factors,
  title,
  icon,
  wordsCount,
  isVisible,
  showChart = true,
  showKeyInsights = false,
}) => {
  const isMobile = useIsMobile();
  const chartData = factorsToChartData(factors);
  
  if (!factors || factors.length === 0) {
    return (
      <div className="mb-16">
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            {title}
          </h3>
        </div>
        <EmptyState 
          message="No behavioral data available for this assessment."
        />
      </div>
    );
  }
  
  return (
    <div className="mb-4">
      <div className="mb-6">
        <h3 className="text-lg font-medium text-foreground">
          {title}
        </h3>
      </div>
      {showChart && (
        <div>
          {chartData.length > 0 ? (
            <DesktopBehavioralChart 
              data={chartData} 
              height={isMobile ? 180 : 300}
              compact={isMobile}
            />
          ) : (
            <EmptyState message="Chart data is not available." />
          )}
        </div>
      )}
    </div>
  );
};

export default BehavioralSection;
